import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyDVHpX3l3Jpb0dpy21g16bIY33rTA-5H-E',
  authDomain: 'lodgefirst-73b4c.firebaseapp.com',
  databaseURL: 'https://lodgefirst-73b4c-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'lodgefirst-73b4c',
  storageBucket: 'lodgefirst-73b4c.firebasestorage.app',
  messagingSenderId: '30792374934',
  appId: '1:30792374934:web:a1257386893abf2b96c0b7',
  measurementId: 'G-QC03F7WLWK',
};

export const getFirebaseApp = (): FirebaseApp => {
  if (getApps().length) return getApp();
  return initializeApp(firebaseConfig);
};
